import React from 'react'
import { MarkerSvgProps } from './MarkerSvgProps'

export const FullSvg = ({ style }: MarkerSvgProps) => {
  return (
    <svg
      width="46"
      height="40"
      viewBox="0 0 46 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g opacity="0.35" filter="url(#filter0_f_8284_162964)">
        <path
          d="M31 34.5C31 35.8807 27.4183 37 23 37C18.5817 37 15 35.8807 15 34.5C15 33.1193 18.5817 32 23 32C27.4183 32 31 33.1193 31 34.5Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.599609 5.0001C0.599609 2.57004 2.56956 0.600098 4.99961 0.600098H40.9996C43.4297 0.600098 45.3996 2.57004 45.3996 5.0001V26.0001C45.3996 28.4302 43.4297 30.4001 40.9996 30.4001H27.2915L24.9526 33.6746C23.9954 35.0146 22.0038 35.0146 21.0466 33.6746L18.7077 30.4001H4.99961C2.56956 30.4001 0.599609 28.4302 0.599609 26.0001V5.0001ZM1.99961 5.0001C1.99961 3.34324 3.34276 2.0001 4.99961 2.0001H40.9996C42.6565 2.0001 43.9996 3.34324 43.9996 5.0001V26.0001C43.9996 27.657 42.6565 29.0001 40.9996 29.0001H27.0857C26.7627 29.0001 26.4596 29.1561 26.2719 29.4189L23.8133 32.8609C23.4145 33.4192 22.5847 33.4192 22.1859 32.8609L19.7273 29.4189C19.5396 29.1561 19.2365 29.0001 18.9136 29.0001H4.99961C3.34276 29.0001 1.99961 27.657 1.99961 26.0001V5.0001Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2C3.34315 2 2 3.34315 2 5V26C2 27.6569 3.34315 29 5 29H18.914C19.2369 29 19.54 29.156 19.7277 29.4188L22.1863 32.8608C22.5851 33.4191 23.4149 33.4191 23.8137 32.8608L26.2723 29.4188C26.46 29.156 26.7631 29 27.086 29H41C42.6569 29 44 27.6569 44 26V5C44 3.34315 42.6569 2 41 2H5Z"
        fill="#FFF3F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3C3.89543 3 3 3.89543 3 5V26C3 27.1046 3.89543 28 5 28H18.914C19.5599 28 20.166 28.3119 20.5414 28.8375L23 32.2795L25.4586 28.8375C25.834 28.3119 26.4401 28 27.086 28H41C42.1046 28 43 27.1046 43 26V5C43 3.89543 42.1046 3 41 3H5ZM2 5C2 3.34315 3.34315 2 5 2H41C42.6569 2 44 3.34315 44 5V26C44 27.6569 42.6569 29 41 29H27.086C26.7631 29 26.46 29.156 26.2723 29.4188L23.8137 32.8608C23.4149 33.4191 22.5851 33.4191 22.1863 32.8608L19.7277 29.4188C19.54 29.156 19.2369 29 18.914 29H5C3.34315 29 2 27.6569 2 26V5Z"
        fill="#EB2D23"
      />
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H30C31.1046 4 32 4.89543 32 6V25C32 26.1046 31.1046 27 30 27H6C4.89543 27 4 26.1046 4 25V6Z"
        fill="#EB2D23"
      />
      <path
        d="M21.5 11.5C21.5 13.433 19.933 15 18 15C16.067 15 14.5 13.433 14.5 11.5C14.5 9.567 16.067 8 18 8C19.933 8 21.5 9.567 21.5 11.5Z"
        fill="white"
      />
      <path
        d="M13 11.5C13 13.433 11.433 15 9.5 15C7.567 15 6 13.433 6 11.5C6 9.567 7.567 8 9.5 8C11.433 8 13 9.567 13 11.5Z"
        fill="white"
      />
      <path
        d="M30 11.5C30 13.433 28.433 15 26.5 15C24.567 15 23 13.433 23 11.5C23 9.567 24.567 8 26.5 8C28.433 8 30 9.567 30 11.5Z"
        fill="white"
      />
      <path
        d="M41 11.5C41 13.433 39.433 15 37.5 15C35.567 15 34 13.433 34 11.5C34 9.567 35.567 8 37.5 8C39.433 8 41 9.567 41 11.5Z"
        fill="#EB2D23"
      />
      <path
        d="M14.5 17.7857C14.5 16.2472 15.7472 15 17.2857 15H18.7143C20.2528 15 21.5 16.2472 21.5 17.7857V23H14.5V17.7857Z"
        fill="white"
      />
      <path
        d="M6 17.7857C6 16.2472 7.24721 15 8.78571 15H10.2143C11.7528 15 13 16.2472 13 17.7857V23H6V17.7857Z"
        fill="white"
      />
      <path
        d="M23 17.7857C23 16.2472 24.2472 15 25.7857 15H27.2143C28.7528 15 30 16.2472 30 17.7857V23H23V17.7857Z"
        fill="white"
      />
      <path
        d="M34 17.7857C34 16.2472 35.2472 15 36.7857 15H38.2143C39.7528 15 41 16.2472 41 17.7857V23H34V17.7857Z"
        fill="#EB2D23"
      />
      <defs>
        <filter
          id="filter0_f_8284_162964"
          x="12"
          y="29"
          width="22"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_8284_162964"
          />
        </filter>
      </defs>
    </svg>
  )
}
